<template>
<div id="catalogo_mt">
  <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
  components: {
    "v-power-catalogo": powerCatalogo
  },
  created() {
    window.getApp.$emit("APP_DRAWER_HIDE");
  },

  data: () => ({
    fab: false,
    parametros: {
      url_actions: "apendices/",
      url_list: "apendices/lista/",
      tabla: 32,
      title: "PERÍODOS ASOCIADOS",
      columns: ["clave", "nombre", "dia_de", "mes_de", "dia_a", "mes_a", "orden", "tipo", "actions"],
      options: {
        filterable: ["clave", "nombre", "dia_de", "mes_de", "dia_a", "mes_a", "orden", "tipo"],
        sortable: ["clave", "nombre", "dia_de", "mes_de", "dia_a", "mes_a", "orden", "tipo"],

        headings: {
          clave: "Clave",
          nombre: "Nombre",
          dia_de: "Día De",
          mes_de: "Mes De",
          dia_a: "Día A",
          mes_a: "Mes A",
          orden: "Orden",
          tipo: "Tipo",
          actions: "Operaciones"
        }
      },
      camposexcel: {
        Clave: "clave",
        Nombre: "nombre",
        Dia_De: "dia_de",
        Mes_De: "mes_de",
        Dia_A: "dia_a",
        Mes_A: "mes_a",
        Orden: "orden",
        Tipo: "tipo"
      },
      encabezadoLayout: {
        clave: "clave",
        nombre: "nombre",
        dia_de: "dia_de",
        mes_de: "mes_de",
        dia_a: "dia_a",
        mes_a: "mes_a",
        orden: "orden",
        tipo: "tipo"
      },
      camposLayout: [{
        clave: "[Clave del Período]",
        nombre: "[Nombre del Período]",
        Dia_De: "[Dia Inicio del Período]",
        Mes_De: "[Mes Inicio del Período]",
        Dia_A: "[Dia Final del Período]",
        Mes_A: "[Mes Final del Período]",
        Orden: "[Orden del Período]",
        Tipo: "[Tipo del Período]",
      }],
      model: {
        id: 0,
        clave: "",
        nombre: "",
        dia_de:"",
        mes_de:"",
        dia_a:"",
        mes_a:"",
        orden:"",
        tipo:""
      },
      form: {
        clave: {
          requiered: true,
          label: "Clave",
          value: "",
          maxlen: 50
        },
        nombre: {
          requiered: true,
          label: "Nombre",
          value: "",
          maxlen: 350
        },
        dia_de: {
          requiered: true,
          label: "Día De",
          value: "",
          maxlen: 10
        },
        mes_de: {
          requiered: true,
          label: "Mes De",
          value: "",
          maxlen: 10
        },
        dia_a: {
          requiered: true,
          label: "Día A",
          value: "",
          maxlen: 10
        },
        mes_a: {
          requiered: true,
          label: "Mes A",
          value: "",
          maxlen: 10
        },
        orden: {
          requiered: true,
          label: "Orden",
          value: "",
          maxlen: 10
        },
        tipo: {
          requiered: true,
          label: "Tipo",
          value: "",
          maxlen: 10
        }
      },
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Utilerías",
          disabled: true,
          to: ""
        },
        {
          text: "Apendices",
          disabled: true,
          to: ""
        }
      ]
    }
  })
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
